import React from 'react';
import { CheckCircle2Icon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { MOCKUP_IMAGE } from '../data/brand';
const chips = ['50 ćwiczeń', '16 tygodni', '3 poziomy', '5 bonusów', 'PDF do druku'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];

/**
 * First screen: title, mockup and the offer button all fit in the viewport
 * on mobile and desktop. Supporting copy sits just below the fold.
 */
export function Hero() {
  return <header id="top" className="bg-ink" data-id="element-79" data-mp="sa027qby5mqy">
      <div className="mx-auto flex min-h-[100svh] max-w-shell flex-col justify-center px-5 py-5 sm:px-6 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-12 lg:py-10" data-id="element-80" data-mp="nc88qrvnlskn">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="3cz5vmcnsk20v">
          <p className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-gold/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-xs" data-id="element-82" data-mp="381e61pamcrzu">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-83" data-mp="3o7vllomspvze" />
            Dla nauczycieli gitary jazzowej
          </p>
          <h1 className="mt-3 font-display text-[2.15rem] font-extrabold leading-[0.92] text-white sm:text-6xl lg:mt-5 lg:text-7xl" data-id="element-84" data-mp="39a38f34q1jod">
            Cały semestr gitary jazzowej <span className="text-gold" data-id="element-85" data-mp="30gzwiz9q5evu">gotowy do uczenia.</span>
          </h1>
          <p className="mt-4 hidden max-w-xl text-lg leading-relaxed text-copy-light lg:block" data-id="element-86" data-mp="3599i633t3ssb">
            Plan na 16 tygodni, 50 gotowych ćwiczeń, teoria i 5 bonusów. Wchodzisz, patrzysz i uczysz.
          </p>
          <div className="mt-8 hidden lg:block" data-id="element-87" data-mp="2vi5558xoyi04">
            <CtaButton data-id="element-88" data-mp="2vgu1d948xa90">Zobacz ofertę</CtaButton>
          </div>
        </div>

        <div className="mt-3 flex justify-center lg:mt-0" data-id="element-89" data-mp="2hjoz7k7nkvj1">
          <img src={MOCKUP_IMAGE} alt="Arsenał Nauczyciela Jazzu: 50 ćwiczeń, 5 bonusów i materiały na komputerze, tablecie i telefonie" className="max-h-[42svh] w-auto max-w-full object-contain sm:max-h-[48svh] lg:max-h-[78vh]" data-id="element-90" data-mp="2lla4okhuy7j7" />
        </div>

        <div className="mt-4 lg:hidden" data-id="element-91" data-mp="ibyowaipsy14">
          <CtaButton fullWidth data-id="element-92" data-mp="id00cg3n7mjd">Zobacz ofertę</CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1" data-id="element-93" data-mp="ddf4iejrruav">
            {assurances.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[11px] text-copy-soft" data-id="element-94" data-mp="1azkvlrn8ois7">
                <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-95" data-mp="16346ov87u0e2" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-5 pb-12 sm:px-6 lg:pb-16" data-id="element-96" data-mp="x1nvil9ktu8s">
        <p className="mx-auto max-w-2xl text-center text-base leading-relaxed text-copy-light lg:hidden" data-id="element-97" data-mp="3lsyt309hwojl">
          Arsenał Nauczyciela Jazzu™ to kompletny pakiet: plan semestru na 16 tygodni, 50 gotowych ćwiczeń,
          teoria i 5 bonusów. Wchodzisz, patrzysz i uczysz.
        </p>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2.5 lg:mt-0" data-id="element-98" data-mp="1x7869rdijxvp">
          {chips.map(chip => <li key={chip} className="flex items-center gap-1.5 text-sm font-medium text-white" data-id="element-99" data-mp="26a9a1lewpcw7">
              <CheckCircle2Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-100" data-mp="2b0pptc679alq" />
              {chip}
            </li>)}
        </ul>
        <ul className="mt-4 hidden flex-wrap justify-center gap-x-5 gap-y-2 lg:flex" data-id="element-101" data-mp="2fzao361w5k7j">
          {assurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-sm text-copy-soft" data-id="element-102" data-mp="2p0h5dhcd6z1u">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-103" data-mp="2tzlgidiun6ut" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}